/**
 * Shared pure helpers + constants for the Posts feature.
 */
import { X } from "@phosphor-icons/react";

export const PLATFORMS = [
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "twitter", label: "Twitter / X" },
  { value: "tiktok", label: "TikTok" },
  { value: "whatsapp", label: "WhatsApp" },
];


export const TONES = ["amigable", "profesional", "divertido", "urgente", "lujoso"];


export const SORT_OPTIONS = [
  { value: "score_desc", label: "Mejor score primero" },
  { value: "recent", label: "Más recientes" },
  { value: "vistas_desc", label: "Más vistas" },
  { value: "engagement_desc", label: "Más interacción" },
  { value: "score_asc", label: "Peor score primero (mejorar)" },
];

// Sum of all engagement signals — useful for "más interacción"


export function totalEngagement(post) {
  const m = post?.metricas || {};
  return (m.likes || 0) + (m.comentarios || 0) * 2 + (m.compartidos || 0) * 3 + (m.clicks || 0);
}

// Inject ?p=<post_id> into the share link so the public product page can
// count clicks automatically. Safe with links that already have query params.


export function withPostTracking(url, postId) {
  if (!url || !postId) return url || "";
  try {
    const u = new URL(url, typeof window !== "undefined" ? window.location.origin : "https://x");
    u.searchParams.set("p", postId);
    return u.toString();
  } catch {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}p=${postId}`;
  }
}


export function tierFromScore(score) {
  if (score >= 60) return { label: "Alto", color: "#00C853", bg: "#E8F5E9" };
  if (score >= 30) return { label: "Medio", color: "#F9A825", bg: "#FFF8E1" };
  return { label: "Bajo", color: "#FF2A00", bg: "#FFEBEE" };
}


export function medalFromRank(rank) {
  if (rank === 1) return { emoji: "🥇", bg: "#FFC107", label: "Top 1" };
  if (rank === 2) return { emoji: "🥈", bg: "#B0BEC5", label: "Top 2" };
  if (rank === 3) return { emoji: "🥉", bg: "#D7A86E", label: "Top 3" };
  return null;
}
